<template>
  <div class="simple-group-config">
    <div class="group-card">
      <h3 class="group-title">对照组</h3>
      <FormItem
        :label="label + '：'"
        :label-width="150"
        :prop="getControlProp()"
        :rules="getControlRules()"
      >
        <div class="field-row">
          <Input
            :disabled="disabled || controlDisabled"
            :value="getControlDisplayValue()"
            @input="handleControlInput($event)"
          />
          <span v-if="unit" class="field-unit">{{ unit }}</span>
        </div>
      </FormItem>
    </div>

    <div
      v-for="index in Array.from({ length: experimentGroupCount }, (_, i) => i)"
      :key="index"
      class="group-card"
    >
      <h3 class="group-title">实验组 {{ index + 1 }}</h3>
      <FormItem
        :label="label + '：'"
        :label-width="150"
        :prop="getProp(index)"
        :rules="[
          {
            required: true,
            message: `请输入${label}`,
            trigger: ['blur', 'change']
          }
        ]"
      >
        <div class="field-row">
          <Input
            :disabled="disabled"
            :value="getGroupValue(index)"
            @input="handleInput(index, $event)"
          />
          <span v-if="unit" class="field-unit">{{ unit }}</span>
        </div>
      </FormItem>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleGroupFieldConfig',
  props: {
    formData: {
      type: Object,
      required: true
    },
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    controlDisabled: {
      type: Boolean,
      default: false
    },
    controlEmptyText: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      default: ''
    },
    configKey: {
      type: String,
      default: ''
    },
    fieldKey: {
      type: String,
      required: true
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getPropPath(prefix) {
      return this.flat
        ? `${prefix}.${this.fieldKey}`
        : `${prefix}.${this.configKey}.${this.fieldKey}`
    },
    getControlProp() {
      if (this.controlDisabled) return undefined
      return this.getPropPath('controlGroupParam')
    },
    getControlRules() {
      if (this.controlDisabled) return []
      return [
        {
          required: true,
          message: `请输入${this.label}`,
          trigger: ['blur'],
          validator: (rule, value, callback) => {
            if (
              this.getControlDisplayValue() !== 0 &&
              !this.getControlDisplayValue()
            ) {
              callback(`请输入${this.label}`)
            } else {
              callback()
            }
          }
        }
      ]
    },
    getControlValue() {
      const control = this.formData.controlGroupParam
      if (!control) return ''

      if (this.flat) {
        return control[this.fieldKey] !== undefined
          ? control[this.fieldKey]
          : ''
      }

      const config = control[this.configKey]
      return config && config[this.fieldKey] !== undefined
        ? config[this.fieldKey]
        : ''
    },
    getControlDisplayValue() {
      const value = this.getControlValue()
      if (this.controlDisabled && this.controlEmptyText) {
        return this.controlEmptyText
      }
      if (value !== '' && value !== undefined && value !== null) {
        return value
      }
      return this.controlDisabled ? this.controlEmptyText : ''
    },
    getGroupValue(index) {
      const groupParam =
        this.formData.groups &&
        this.formData.groups[index] &&
        this.formData.groups[index].experimentGroupParam

      if (!groupParam) return ''

      if (this.flat) {
        return groupParam[this.fieldKey] !== undefined
          ? groupParam[this.fieldKey]
          : ''
      }

      const config = groupParam[this.configKey]
      return config && config[this.fieldKey] !== undefined
        ? config[this.fieldKey]
        : ''
    },
    getProp(index) {
      return this.getPropPath(`groups[${index}].experimentGroupParam`)
    },
    handleInput(index, value) {
      const group = this.formData.groups[index]
      if (!group || !group.experimentGroupParam) return

      if (this.flat) {
        this.$set(group.experimentGroupParam, this.fieldKey, value)
        return
      }

      if (!group.experimentGroupParam[this.configKey]) {
        this.$set(group.experimentGroupParam, this.configKey, {})
      }

      this.$set(
        group.experimentGroupParam[this.configKey],
        this.fieldKey,
        value
      )
    },
    handleControlInput(value) {
      if (this.controlDisabled) return
      if (this.flat) {
        this.$set(this.formData.controlGroupParam, this.fieldKey, value)
        return
      }
      if (!this.formData.controlGroupParam[this.configKey]) {
        this.$set(this.formData.controlGroupParam, this.configKey, {})
      }
      this.$set(
        this.formData.controlGroupParam[this.configKey],
        this.fieldKey,
        value
      )
    },
    validate() {
      if (this.controlDisabled) return true
      if (!this.getControlValue()) {
        this.$Message.error(`请输入${this.label}`)
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="less">
.simple-group-config {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin: 20px 0;
}

.group-card {
  flex: 0 1 45%;
  box-sizing: border-box;
  border: 1px solid #e8eaec;
  padding: 20px;
  border-radius: 4px;
}

.group-title {
  margin-bottom: 20px;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.field-row /deep/ .ivu-input-wrapper {
  flex: 1;
  min-width: 0;
}

.field-unit {
  flex-shrink: 0;
  white-space: nowrap;
}
</style>
